const ReceivingProductReorder = () => {
  return <div>ReceivingProductReorder</div>;
};
export default ReceivingProductReorder;
